if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      window.requestAnimationFrame(() => this.showActiveMedia());
    }

    showActiveMedia() {
      const openedMediaId = this.openedBy?.getAttribute("data-media-id");
      this.querySelectorAll("[data-media-id]").forEach((element) => {
        element.classList.remove("active");
      });

      let activeMedia = openedMediaId
        ? this.querySelector(`[data-media-id="${openedMediaId}"]`)
        : null;
      if (!activeMedia || activeMedia.hidden || activeMedia.style.display === "none") {
        activeMedia = this.querySelector(
          '[data-media-id]:not([hidden]):not([style*="display: none"])'
        );
      }
      if (!activeMedia) return;

      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');

      const container = this.querySelector('[role="document"]');
      if (container) {
        container.prepend(activeMedia);
        container.scrollTop = 0;
      }

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}